import { BaseStorage } from "./BaseStorage";
import { Logger } from "./Logger";
import { MainCommand } from "./MainCommand";
export class Application
{
    public logger: Logger;
    public storage: BaseStorage;
    public main: MainCommand;
    constructor(name: string, storage: BaseStorage, commands: { [name: string]: any })
    {
        this.logger = new Logger();
        this.storage = storage;
        let argv = process.argv.slice(2);
        this.main = new MainCommand(argv, commands);
        this.main.app = this;
        this.main.name = name;
        this.main.parent = null;
    }
    run()
    {
        try
        {
            this.main.run();
        } catch (error: any)
        {
            this.logger.error(error.message ?? error);
            process.exit(1);
        }
    }
}